
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/api/stack",
      function () {
        return require("private-next-pages/system/api/stack.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/api/stack"])
      });
    }
  